import React from 'react';

interface ContentBoxProps {
    title?: string;
    children: React.ReactNode;
    footerContent?: React.ReactNode;
    action?: React.ReactNode;
    className?: string;
    id?: string;
}

const OdxContentBox: React.FC<ContentBoxProps> = ({
    title,
    children,
    footerContent,
    action,
    className = "",
    id,
}) => {
    return (
        <div className={`odx-content-box ${className}`} id={id}>
            {title && (
                <div className="odx-content-box__header">
                    <h5 className="odx-title-5">{title}</h5>
                    {action && <div className="odx-content-box__action">{action}</div>}
                </div>
            )}
            <div className="odx-content-box__content">{children}</div>
            {footerContent && (
                <div className="odx-content-box__footer">{footerContent}</div>
            )}
        </div>
    );
};

export default OdxContentBox;
